import React, { useState } from 'react';
import { PUBLIC_IMG_URL } from '../../../../lib/endpoints';

const ECOSYSTEM_TABS = [
    {
        id: 'investors',
        image: 'investors-new.png',
        label: 'Investors & VCs',
        tag: 'For Investors & VCs',
        headline: 'Deal Intelligence & Portfolio Benchmarking',
        description: 'Track live deal flow, benchmark your portfolio against peers, and identify co-investment opportunities across MENA, Africa, and Southeast Asia.',
        bullets: [
            'Identify emerging deals before they close with real-time funding round tracking',
            'Benchmark deployment, stage mix, and sector allocation against comparable GPs',
            'Profile co-investors and map syndication networks across 5 regions',
            'Build LP-ready reports with verified data exports',
        ],
        ctaSecondaryLabel: 'See Investor Analytics',
        ctaSecondaryLink: '/investors',
    },
    {
        id: 'government',
        image: 'government.png',
        label: 'Government & DFIs',
        tag: 'For Government & DFIs',
        headline: 'Ecosystem Intelligence & Policy Benchmarking',
        description: 'Track your ecosystem\'s health, benchmark against peer markets, and generate verified reporting for policy design, grant allocation, and impact measurement.',
        bullets: [
            'Compare your country\'s venture activity against peer markets with side-by-side benchmarking',
            'Track funding gaps by sector, stage, and geography to inform policy interventions',
            'Generate quarterly ecosystem reports with verified, exportable data',
            'Monitor the impact of government-backed accelerators, incubators, and programs',
        ],
        ctaSecondaryLabel: 'See Ecosystem Analytics',
        ctaSecondaryLink: '/advanced-analytics',
    },
    {
        id: 'corporates',
        image: 'corporates.png',
        label: 'Corporates',
        tag: 'For Corporates',
        headline: 'Market Mapping & Strategic Deal Sourcing',
        description: 'Identify acquisition targets, map technology trends by sector, and evaluate the startup landscape in your industry — powered by verified deal-level data.',
        bullets: [
            'Screen startups by industry, stage, and geography to find acquisition and partnership targets',
            'Track which investors are backing companies in your sector',
            'Benchmark CVC activity against peer corporates across emerging markets',
            'Build custom market maps with MAGNiTT\'s research team for board-level reporting',
        ],
        ctaSecondaryLabel: 'See Corporate Analytics',
        ctaSecondaryLink: '/investors',
    },
    {
        id: 'service',
        image: 'service-providers.png',
        label: 'Service Providers',
        tag: 'For Service Providers',
        headline: 'Client Intelligence & Market Positioning',
        description: 'Equip your advisory, legal, or consulting practice with verified startup and investor data to win mandates, advise clients, and track market activity.',
        bullets: [
            'Identify high-growth startups and their investors to target advisory mandates',
            'Track deal flow by sector and geography to anticipate where advisory demand will emerge',
            'Enrich client presentations with verified market data and benchmarks',
            'Monitor accelerator cohorts and program performance for incubator partners',
        ],
        ctaSecondaryLabel: 'See Service Provider Solutions',
        ctaSecondaryLink: '/startups',
    },
];

export default function Ecosystem() {
    const [activeTab, setActiveTab] = useState('investors');
    const tab = ECOSYSTEM_TABS.find(t => t.id === activeTab);

    return (
        <section className="lp-ecosystem">
            <div className="lp-ecosystem__header">
                <h2>Built for every player in the ecosystem</h2>
                <p>
                    Whether you're deploying capital, benchmarking a market, or sourcing partnerships —
                    MAGNiTT gives you the data edge.
                </p>
            </div>

            <div className="lp-ecosystem__tabs">
                {ECOSYSTEM_TABS.map(t => (
                    <button
                        key={t.id}
                        className={`lp-ecosystem__tab${activeTab === t.id ? ' lp-ecosystem__tab--active' : ''}`}
                        onClick={() => setActiveTab(t.id)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="row lp-ecosystem__content" key={activeTab}>
                <div className="col-md-6 lp-ecosystem__text">
                    <span className="lp-ecosystem__tag">{tab.tag}</span>
                    <h3>{tab.headline}</h3>
                    <p>{tab.description}</p>
                    <ul className="lp-ecosystem__bullets">
                        {tab.bullets.map((b, i) => <li key={i}>{b}</li>)}
                    </ul>
                    <div className="lp-ecosystem__cta-row">
                        <a className="btn btn-main" href={tab.ctaSecondaryLink}>
                            {tab.ctaSecondaryLabel}
                        </a>
                    </div>
                </div>

                <div className="col-md-6 lp-ecosystem__image">
                    <img
                        src={`${PUBLIC_IMG_URL}/anonymous-landing-page/ecosystem-${tab.image}`}
                        alt={tab.headline}
                    />
                </div>
            </div>
        </section>
    );
}
